import Header from "./components/Header"
import Footer from "./components/Footer"
import JwtDecoder from "./components/JwtDecoder"
import "./App.css"

function App() {
  return (
    <>
      <Header />
      <main className="main">
        <div className="container">
          <JwtDecoder />
        </div>
      </main>
      <Footer />
    </>
  )
}

export default App
